import React from 'react'

import { i18n } from '~/i18n'
import formatCurrency from '~/utils/format-currency'

import {
  BlueCheckboxInput,
  Logo,
  ProductLine,
  ProductPrice,
  CartPassInsurance,
  StyledAddonInfoButton,
  AddonHeading,
  AddonBody,
  Wrapper,
} from './applicable-addon-rows.styles'

import type { ApplicableCartAddon } from '~/types'

type Props = {
  applicableAddons: ApplicableCartAddon[]
  isUpgrade?: boolean
  toggleAddon?: (state: boolean, addonType: string) => any
}

export default function ApplicableAddonRows({
  applicableAddons,
  isUpgrade,
  toggleAddon,
}: Props) {
  const showSpotLogo = !isUpgrade && applicableAddons.length > 0

  return (
    <Wrapper>
      {applicableAddons.map(({ price, product, added, type }) => {
        const addonAppliedOrAllowed = !isUpgrade || added

        const PassProtectionHeading = () => {
          if (!addonAppliedOrAllowed) {
            return <>{i18n.t(`addons.${product}.ineligible`)}</>
          }

          return (
            <div>
              <AddonHeading>
                {i18n.t(`addons.${product}.applicable`)}
              </AddonHeading>
              <AddonBody>{i18n.t(`addons.${product}.summary`)}</AddonBody>
            </div>
          )
        }

        const AddonInfo = () => (
          <CartPassInsurance>
            <PassProtectionHeading />
            {!isUpgrade && <StyledAddonInfoButton addonProduct={product} />}
          </CartPassInsurance>
        )

        const AddonToggle = () => (
          <BlueCheckboxInput
            checked={added}
            label={<AddonInfo />}
            onChange={(state) => toggleAddon && toggleAddon(state, product)}
          />
        )

        return (
          <ProductLine key={product + type} data-testid="addon-line">
            {!isUpgrade ? <AddonToggle /> : <AddonInfo />}
            {addonAppliedOrAllowed && (
              <ProductPrice $insuranceAwaitingApplication={!added}>
                {!added && '+'} {formatCurrency(price)}
              </ProductPrice>
            )}
          </ProductLine>
        )
      })}
      {showSpotLogo && <Logo />}
    </Wrapper>
  )
}
